import { auth } from '../firebase'
import { sendFeatureRequest } from './featureRequestPayload.mjs'

/** Unlike background telemetry, this resolves only after a confirmed log save. */
export function submitFeatureRequest(input) {
  return sendFeatureRequest(input, { user: auth.currentUser, getCurrentUser: () => auth.currentUser })
}
